import {WebmateToolConfig} from '@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.service';
import {AuditActivityId, AuditId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {HydratedAuditTarget} from '@webmate-web-core/shared/services/audit.service';
import {Component, Inject} from '@angular/core';
import {TOOL_CONTAINER_DATA} from '@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.component';

export class PlanningMatrixToolConfig implements WebmateToolConfig {
    scrollable = true;

    constructor(public toolName: string, public projectId: ProjectId, public auditId: AuditId, public selectMode: boolean, public preselectedActivities?: AuditActivityId[], public onlySelectOne?: boolean,
                public doneCallback?: (activities: {[specId: string]: HydratedAuditTarget[]}) => void) {}
}

@Component({
    templateUrl: './planningmatrix-selection-tool.component.html',
    styleUrls: ['./planningmatrix-selection-tool.component.less'],
})
export class PlanningMatrixSelectionToolComponent {
    projectId: ProjectId;
    onlySelectOne: boolean;

    constructor(@Inject(TOOL_CONTAINER_DATA) public data: PlanningMatrixToolConfig) {
        this.projectId = data.projectId;
        this.onlySelectOne = data.onlySelectOne;
    }

    onSelectionConfirmed(activities: {[specId: string]: HydratedAuditTarget[]}): void {
        this.data.doneCallback?.(activities);
    }
}
